import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { ButtonContainer, Explanation, TextContainer, TopSpacer } from "./PatientSwitchOrganizationView.styles";
import { PatientSwitchOrganizationViewModel } from "./PatientSwitchOrganizationViewModel";
import { useViewModel } from "./useViewModel";
import { useTranslation } from "react-i18next";
import { PreLoginBaseView } from "./PreLoginPageBaseView";
import { HXMobileButton } from "./HXButton";
import { spinner } from "./Spinner";
import { NOT_LOADED } from "../Infra/RemoteData";
export const PatientSwitchOrganizationView = observer((props) => {
    var _a;
    const { t } = useTranslation(["patients"]);
    const model = useViewModel(PatientSwitchOrganizationViewModel, props.container);
    if (model.healthcareOrganizationToSwitchTo === NOT_LOADED) {
        return spinner();
    }
    return (_jsxs(PreLoginBaseView, { title: t("You’re already logged in to another account"), organization: (_a = model.healthcareOrganizationToSwitchTo) !== null && _a !== void 0 ? _a : undefined, topImage: _jsx(TopSpacer, {}), container: props.container, showLanguageSwitcher: true, children: [_jsxs(TextContainer, { children: [_jsx(Explanation, { children: t("This link requires access to a different account.") }), _jsx(Explanation, { children: model.toContinueText })] }), _jsxs(ButtonContainer, { children: [_jsx(HXMobileButton, { onClick: (e) => {
                            e.preventDefault();
                            model.logout();
                        }, children: t("Log out and switch accounts") }), _jsx(HXMobileButton, { onClick: (e) => {
                            e.preventDefault();
                            model.stayLoggedIn();
                        }, secondary: true, children: t("Stay logged in to current account") })] })] }));
});
